import React, { useEffect } from 'react';

const Contact = () => {
    const baseUrl = 'https://jermingo.com';
    
    useEffect(() => {
        // Update document title
        document.title = 'Contact Us | Jermingo';
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', 
            'Get in touch with Jermingo. Contact us via email or connect with us on social media. We\'d love to hear from you!'
        );
        
        // Add canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `${baseUrl}/contact`);
    }, []);
    
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h1>Contact Us</h1>
            <p>Welcome to Jermingo's contact page! Feel free to reach out to us through the following:</p>
            
            <h2>Email</h2>
            <ul>
                <li>Ming: ming@jermingo.com</li>
                <li>Jermaine: jermaine@jermingo.com</li>
            </ul>
            
            <h2>Socials</h2>
            <ul>
                <li>Twitter: <a href="https://twitter.com/jermingo" target="_blank" rel="noopener noreferrer">@jermingo</a></li>
                <li>Instagram: <a href="https://instagram.com/jermingo" target="_blank" rel="noopener noreferrer">@jermingo</a></li>
            </ul>
            
            <p>We look forward to hearing from you!</p>
        </div>
    );
};

export default Contact;